import React from 'react';
import './styles.scss';

const ListCardGreen = ({ children, className }) => (
  <div className={`${className} list-card list-card-green`}>{children}</div>
);
export default ListCardGreen;
